import React from "react";
import { Button, Box, useTheme, useMediaQuery } from "@mui/material";
import useGA4Event from "../hooks/useGA4Event";

export default function ContinueButton(props) {
    const sendGA4Event = useGA4Event();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

    const handleClick = (event) => {
        sendGA4Event('button_click', {
            'button_id': props.id || 'move_button',
            'button_text': props.title,
            'button_state': props.selected ? 'selected' : 'unselected',
            'page_path': window.location.pathname,
        });

        if (props.onClick) {
            props.onClick(event);
        }
    };

    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            flex: '0 0 auto',
            ...props.containerSx
        }}>
            <Button
                variant={"outlined"}
                color="secondary"
                sx={{
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 600,
                    minHeight: "clamp(40px, 6vh, 70px)",
                    fontSize: "clamp(10px, 2.5vh, 14px)",
                    maxWidth: "600px",
                    width: isDesktop ? "300px" : "100%",
                    borderStyle: "solid",
                    borderWidth: "2px",
                    borderColor: props.selected ? "piction.highlight" : "grayTones.piction",
                    backgroundColor: props.selected ? "piction.highlight" : "white",
                    color: props.selected ? "white" : "black",
                    borderRadius: "25px",
                    '&:hover': {
                        backgroundColor: props.selected ? "piction.bgHighlight" : "rgba(34, 0, 187, 0.04)",
                        borderColor: "piction.highlight",
                        borderWidth: "2px",
                        color: props.selected ? "black" : "piction.highlight",
                    },
                    '&:disabled': {
                        backgroundColor: "grey.200",
                        borderColor: "grey.400",
                        color: "grey.500",
                    },
                    transition: 'all 0.3s ease',
                    margin: '0 auto',
                    ...props.sx,
                }}
                onClick={handleClick}
                disabled={props.disabled}
            >
                {props.title}
            </Button>
        </Box>
    );
}